import { CountCellProps } from '../../types';
import { pendingCreateOnTargetStrings, pendingUpdateOnTargetStrings } from '@constants';
import { Tooltip } from '@mui/material';
import TextWithSubtitle from 'components/TextWithSubtitle';
import { StyledCountWithSubtitleContainer } from './styles';
import { formatNumberWithComma } from 'utils';

const IntegrationServerToAgentCountsCell = ({
  _customRowProps: { onPendingCellClick },
  pendingToTarget,
  data,
}: CountCellProps) => {
  const { CREATE_NEW_ON_TARGET, UPDATE_ON_TARGET, dataType } = data;

  return (
    <Tooltip
      placement="top"
      title={
        <div>
          <p>Create on Target: {formatNumberWithComma(+CREATE_NEW_ON_TARGET)}</p>
          <p>Update on Target: {formatNumberWithComma(+UPDATE_ON_TARGET)}</p>
        </div>
      }
    >
      <StyledCountWithSubtitleContainer>
        {' '}
        <TextWithSubtitle
          mainText={formatNumberWithComma(pendingToTarget)}
          mainTextProps={{
            onClick: pendingToTarget
              ? () => onPendingCellClick([dataType], pendingCreateOnTargetStrings)
              : undefined,
          }}
          mainTextClassName={+pendingToTarget ? 'link-style clickable' : ''}
          subTitleClassName={+UPDATE_ON_TARGET ? 'subtitle link-style clickable' : 'subtitle'}
          subtitle={formatNumberWithComma(+UPDATE_ON_TARGET)}
          subtitleProps={{
            onClick: +UPDATE_ON_TARGET
              ? () => onPendingCellClick([dataType], pendingUpdateOnTargetStrings)
              : undefined,
          }}
        />
      </StyledCountWithSubtitleContainer>
    </Tooltip>
  );
};

export default IntegrationServerToAgentCountsCell;
